const BREAKPOINTS_DEVICES = {
  MOBILE: 320,
  MOBILEBIG: 480,
  PHABLET: 660,
  TABLET: 768,
  DESKTOP: 960,
  WIDE: 1366
};

const imageSizes = {
  standardWidths: {
    '320w': {
      r: {
        width: 320
      }
    },
    '480w': {
      r: {
        width: 480
      }
    },
    '660w': {
      r: {
        width: 660
      }
    },
    '768w': {
      r: {
        width: 768
      }
    },
    '1024w': {
      r: {
        width: 1024
      }
    },
    '1366w': {
      r: {
        width: 1366
      }
    }
  },
  squares: {
    '102w': {
      r: {
        width: '102',
        height: '102'
      }
    }
  },
  '3:2': {
    '320w': {
      r: {
        width: '320',
        height: '213'
      }
    },
    '480w': {
      r: {
        width: '480',
        height: '320'
      }
    },
    '660w': {
      r: {
        width: '660',
        height: '440'
      }
    },
    '768w': {
      r: {
        width: '768',
        height: '512'
      }
    },
    '1024w': {
      r: {
        width: '1024',
        height: '683'
      }
    },
    '1366w': {
      r: {
        width: '1366',
        height: '911'
      }
    }
  },
  '16:9': {
    '320w': {
      r: {
        width: 320,
        height: 180
      }
    },
    '480w': {
      r: {
        width: 480,
        height: 270
      }
    },
    '660w': {
      r: {
        width: 660,
        height: 371
      }
    },
    '768w': {
      r: {
        width: 768,
        height: 432
      }
    },
    '960w': {
      r: {
        width: 960,
        height: 540
      }
    },
    '1280w': {
      r: {
        width: 1280,
        height: 720
      }
    }
  }
};

const RESPONSIVE_IMAGE_CONFIG = process.env.DISABLE_RESPONSIVE_IMAGES
  ? null
  : {
      sizes: {
        socialMeta: {
          single: {
            r: {
              width: 1280
            }
          }
        },
        'card:landscape:grid--one:sidebar-card': {
          widths: {
            '320w': imageSizes['16:9']['320w'],
            '660w': imageSizes['16:9']['660w']
          },
          sizes: '(max-width: 960px) 40vw, 10vw'
        },
        'card:portrait:grid--two': {
          widths: imageSizes['16:9'],
          sizes: '(max-width: 768px) 100vw, 50vw'
        },
        'card:portrait:grid--three': {
          widths: imageSizes['16:9'],
          sizes: '(max-width: 768px) 100vw, 33vw'
        },
        'card:portrait:grid--four': {
          widths: imageSizes['16:9'],
          sizes: '(max-width: 768px) 50vw, 25vw'
        },
        'card:landscape:grid--two': {
          widths: imageSizes['16:9'],
          sizes: '(max-width: 768px) 40vw, 10vw'
        },
        // standard listing e.g. news
        'card:landscape:grid--one': {
          widths: imageSizes['3:2'],
          sizes: '(max-width: 768px) 100vw, (max-width: 1024px) 20vw, 15vw'
        },
        // service circle images on homepage
        'card:landscape:grid--four:online-services-circle': {
          widths: imageSizes.squares,
          sizes: '100vw'
        },
        // councillor circle images on homepage
        'card:landscape:grid--three:featured-councillors-circle': {
          widths: imageSizes.squares,
          sizes: '100vw'
        },
        // councillor circle images on councillors listing (STAGE)
        'card:portrait:grid--three:councillor-cards': {
          widths: imageSizes.squares,
          sizes: '100vw'
        },
        // councillor circle images on councillors listing (PROD)
        'card:landscape:grid--three:councillor-cards': {
          widths: imageSizes.squares,
          sizes: '100vw'
        },
        // councillor circle images in RHS listing on councillor page
        'card:landscape:grid--one:card-other-councillors': {
          widths: imageSizes.squares,
          sizes: '100vw'
        },
        // councillor circle images on search result page
        'card:landscape:grid--two:councillor-cards': {
          widths: imageSizes.squares,
          sizes: '100vw'
        },
        card: {
          widths: imageSizes['16:9'],
          sizes: '100vw'
        },
        globalLightbox: {
          widths: imageSizes.standardWidths,
          sizes: '100vw'
        },
        carousel: {
          widths: {
            // 525w is wrong but will trigger srcset correctly
            '525w': {
              r: {
                height: 350
              }
            }
          },
          sizes: '100vw'
        }
      }
    };

export { BREAKPOINTS_DEVICES, RESPONSIVE_IMAGE_CONFIG };
